import type { FeaturePageSeo } from "@/components/feature-template/seo";
import type { FAQItem } from "@/components/feature-template/types";

// Shared by page.tsx (JSON-LD) and the client page (visible FAQ) so both always match.

export const faqs: FAQItem[] = [
  {
    question: "What is a JobFit score?",
    answer:
      "It is a score from 0 to 100 that shows how well your resume matches a specific job description, based on the signals applicant tracking systems use to rank candidates.",
  },
  {
    question: "How is the score calculated?",
    answer:
      "In ATS Match mode the score is weighted across five checks: keywords (30%), evidence quality (20%), completeness (20%), formatting (15%) and readability (15%). Each weight is shown next to its score, so you can see exactly where points are lost.",
  },
  {
    question: "What is the difference between ATS Match and Profile Review?",
    answer:
      "ATS Match compares your resume with a job description you paste in. Profile Review needs no posting and scores your resume on completeness, formatting, readability, skills diversity and impact evidence.",
  },
  {
    question: "What score should I aim for?",
    answer:
      "75 or above is a strong match. Between 50 and 74, the recommendations usually point to a few quick fixes. Below 50, the role needs substantial tailoring or may not be the right fit.",
  },
  {
    question: "Is my resume stored?",
    answer:
      "No. Your resume is processed in memory for the analysis and is not saved. The file is discarded as soon as your results are ready.",
  },
  {
    question: "Which file formats can I use?",
    answer:
      "Upload your resume as a PDF or paste the text directly. Both give the same results.",
  },
  {
    question: "Does a high score guarantee an interview?",
    answer:
      "No tool can promise that. A high score means your resume is readable and relevant enough to reach a recruiter, which is the step most applications never get past.",
  },
];

export const seo: FeaturePageSeo = {
  slug: "resume-jobfit-scorer",
  name: "Resume JobFit Scorer",
  title: "Resume JobFit Scorer: Free ATS Resume Checker | MindMyJob",
  description:
    "Score your resume against any job description. See your ATS match score, missing keywords and ranked fixes in seconds. Your resume is never stored.",
  keywords: [
    "ats resume checker",
    "resume score checker",
    "resume job match score",
    "resume keyword scanner",
    "ats compatibility check",
    "missing keywords resume",
    "resume analyzer free",
    "job description resume match",
    "ats score",
    "resume optimization tool",
  ],
  ogImage: "/assets/images/features/resume-jobfit-scorer/hero-match-score.png",
  ogImageAlt:
    "MindMyJob Resume JobFit Scorer showing an 82 match score with weighted breakdown",
  featureList: [
    "ATS match score against any job description",
    "Profile Review without a job description",
    "Weighted breakdown across five checks",
    "Matched and missing keywords",
    "Hard and soft skills gap analysis",
    "Recommendations ranked by impact",
    "Resume processed in memory and never stored",
  ],
  faqs,
};
